<!-- <img class="img-fluid rounded" style="max-height: 400px;" [src]="'https://http.cat/' + answer.errorCode"> -->
<div style="position: absolute; top: 50%; width: 100%; text-align: center;">
  <p>
    {{errorMsg | translate}}
  </p>
</div>
<!-- <p>
  {{answer.errorCode}}
</p>
<p>
  {{answer.errorMessage}}
</p> -->
